const styles = (theme) => ({
  alignLeft: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: '10px'
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: '10px'
  },
  remarksButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px'
  },
  inlineEdit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: '10px',
    marginTop: '5px'
  },
  bold: {
    fontWeight: '700'
  },
  border: {
    borderBottom: 'solid gray 2px'
  },
});
export default styles;
